<template>
    <brick-settings-base
        v-if="show" 
        v-model="newName"
        :title="resource('JourneyComposer_BrickSettingsJourney_Title')"
        :canWrite="canWrite"
        :prompt="{
            title: resource('JourneyBuilder_JourneySettings_Delete_Title'),
            body: resource('JourneyBuilder_JourneySettings_Delete_Body')
        }"

        @save="saveSettings"
        @delete="$emit('delete')"
        @hidden="$emit('hide')"
    >

        <settings-item icon="fas fa-route">
            
            <template v-slot:label>
                <label :for="fieldName">{{fieldName}}</label>
            </template>

            <template v-slot:input>
                <v-select class="form-control" :id="fieldName"
                    v-model="selectedJourney"
                    :options="journeys"
                    :disabled="!canWrite || journeys.length === 0"
                    :clearable="false"

                    searchable
                    filterable
                >
                    <template v-slot:no-options />
                </v-select>
            </template>

        </settings-item>
        
    </brick-settings-base>
</template>

<script>
    
    import brickTypes from '../../../../Bricks/brick-types';
    import {brickDefinitions} from "../../../../Bricks/brick-definitions";
    
    import brickSettingsBase from '../BrickSettingsBase.vue';
    import brickSettings from '../../../../Mixins/brick-settings';
    
    export default {
        name: 'journey-brick-settings-journey',
        components: {
            brickSettingsBase
        },
        mixins: [brickSettings],
        created() {
            //Make journeyId reactive
            this.$set(this.settings, 'journeyId', this.settings.journeyId || undefined);
            
            this.getJourneys((journeys) => {
                const selectableJourneys = journeys.map((journey) => {
                    return {
                        label: journey.name,
                        id: journey.id
                    };
                });
                
                if(this.settings.journeyId)
                {
                    //Temporary workaround until we implement a better solution
                    //if for example our current journey becomes unavailable to moving division
                    //we don't want to completely break the brick when 'edit' is clicked
                    if(selectableJourneys.findIndex(j => j.id === this.settings.journeyId) === -1){
                        selectableJourneys.push({
                            label: this.name,
                            id: this.settings.journeyId
                        });
                    }   
                }
                
                this.journeys = selectableJourneys;
            });
        },
        computed: {
            selectedJourney: {
                get(){
                    return this.journeys.find(journey => journey.id === this.settings.journeyId)
                },
                set(value){
                    this.settings.journeyId = value ? value.id : undefined;
                }
            }
        },
        watch: {
            'selectedJourney.label'(newLabel, oldLabel) {
                const defaultLabel = brickDefinitions[brickTypes.journey].displayName;
                
                //newName should change along with selected journey when name equals old journey name
                //or has not been changed (= default)
                if(this.newName === oldLabel || this.newName === defaultLabel){
                    this.newName = newLabel || defaultLabel;
                }
            }
        },
        data() {
            return {
                journeys: [],
                fieldName: this.resource('JourneyComposer_BrickSettingsJourney_Journey_DisplayName')
            }
        }
    };
</script>

<style lang="scss" scoped>

</style>